import React from 'react';
import { Input } from '@weezevent/nacre';
import css from './modal-summary.module.css';

function OptionalItem({ name, onChange, value }) {
    return (
        <div className={css['summary-attendee-optional-items']}>
            <span>{name}</span>
            <Input type="text" value={value} onChange={onChange} />
        </div>
    );
}

export default OptionalItem;
